import PageSection from '../../../Constants&Theme/PageSection'
import { Box } from '@mui/material'
import {
  DataGridPro,
  GridPaginationModel,
  GridRowId,
} from '@mui/x-data-grid-pro'
import { useGetLimsSamples } from '../../../APIs/Hooks/LimsHooks'
import { sampleSaleCols } from './SampleSaleCols'
import SampleAsyncToolbar from '../SharedItems/SampleAsyncToolbar'
import React, { useMemo, useState } from 'react'
import SaleItemDGToolbar from '../SaleItems/SaleItemDGToolbar'
import { useLocalStorage } from 'usehooks-ts'
import RenderMessage from '../../../garvan-react/Components/ModalFeedback/RenderMessage'
import { tsGetLimsSampleFilters } from '../../../Typescript/UI_Interfaces'
import { biobankItemCategory } from '../../../Typescript/TS_Types'
import { tsLimsSample } from '../../../Typescript/StuartPy/Lims'

function ItemsPage({ category }: { category: biobankItemCategory }) {
  const [apiFilters, setApiFilters] = useState<tsGetLimsSampleFilters>({
    category: category,
    enabled: false,
  })
  const [pagination, setPagination] = useState<GridPaginationModel>({
    //DG grid is 0 based index, while API is 1 based index
    // state stored in DG 0 based -> then +1 for API
    page: 0,
    pageSize: 12,
  })
  const [selection, setSelection] = useState<any[]>([])
  const [picked, setPicked] = useState<GridRowId[]>([])
  const [cart, setCart] = useLocalStorage(
    'BioBankShoppingCart',
    [] as tsLimsSample[],
  )
  // Need to preserve since limsSamplesQuery is undefined while fetching and async reset to 0 resets pagination model
  const [totalRecords, setTotalRecords] = useState(25)
  const limsSamplesQuery = useGetLimsSamples(
    apiFilters,
    pagination,
    setTotalRecords,
  )

  let dgProps = {}
  if (category === 'Sale') {
    dgProps = {
      slots: {
        toolbar: SaleItemDGToolbar as any,
      },
      slotProps: {
        toolbar: {
          selection: Array.from(new Set([...selection, ...picked])),
          setCart,
          clear: () => {
            setSelection([])
            setPicked([])
          },
          cart,
        },
      },
    }
  }

  const showItems = useMemo(() => {
    if (limsSamplesQuery.data?.data && apiFilters.enabled) {
      if (category) {
        return limsSamplesQuery.data.data.filter(
          (r) => !cart.map((c) => c.id).includes(r.id),
        )
      } else {
        return limsSamplesQuery.data.data
      }
    } else {
      return []
    }
  }, [limsSamplesQuery, apiFilters, category, cart])

  return (
    <Box sx={{ maxWidth: 'xl', width: 1 }}>
      <PageSection
        title={
          category === 'Researcher' ? 'Tissue Storage' : (
            'Available Tissue for Purchase'
          )
        }
      >
        <SampleAsyncToolbar
          apiFilters={apiFilters}
          setApiFilters={setApiFilters}
          category={category}
        />
        {apiFilters.enabled ?
          <DataGridPro
            sx={{ width: 1 }}
            {...dgProps}
            autoHeight
            pagination
            disableColumnMenu
            checkboxSelection
            paginationMode="server"
            paginationModel={pagination}
            onPaginationModelChange={(m, details) => {
              setPicked((p) => {
                return [...p, ...selection]
              })
              setPagination(m)
            }}
            rowCount={totalRecords ?? 50}
            rowSelectionModel={selection.map((s) => s.id)}
            onRowSelectionModelChange={(m) => {
              if (limsSamplesQuery.data?.data) {
                setSelection(
                  limsSamplesQuery.data.data.filter((row) =>
                    m.includes(row.id),
                  ),
                )
              }
            }}
            loading={limsSamplesQuery?.isFetching}
            pageSizeOptions={[12, 25, 50, 100]}
            columns={sampleSaleCols}
            initialState={{
              columns: {
                columnVisibilityModel: {
                  Price: false,
                },
              },
            }}
            rows={showItems}
          />
        : <RenderMessage
            message={{
              message:
                'Please select one or more filters above and click "search" to view items',
              subject: 'Select a filter',
              severity: 'info',
              loading: false,
            }}
          />
        }
      </PageSection>
    </Box>
  )
}

export default ItemsPage
